import objectPath from 'object-path'

const getRuleFetchTableTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

export const onRuleFetchTable = (
  designContext = {},
  action = {},
  target = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let targetKey = getRuleFetchTableTarget(action, target)
  if (!targetKey) return undefined

  objectPath.set(isUiChanged, targetKey, {
    isRender: true,
    isFetchTable: true,
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: targetKey,
    isFetchTable: true,
  }
}
